import {TooManyProjectsErrorBanner} from './subscriptions/TooManyProjectsErrorBanner.tsx'
import {TooManyConnectionsErrorBanner} from './subscriptions/TooManyConnectionsErrorBanner.tsx'
import {NoActiveSubscriptionErrorBanner} from './subscriptions/NoActiveSubscriptionErrorBanner.tsx'
import {NoProjectErrorBanner} from './projects/NoProjectErrorBanner.tsx'
import {Flex} from '@mantine/core'
import {EmailNotVerifiedErrorBanner} from './auth/EmailNotVerifiedErrorBanner.tsx'

export const ErrorBanners = () => {
  return (
    <Flex justify={'center'} gap={'xs'}>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <EmailNotVerifiedErrorBanner />
        <NoActiveSubscriptionErrorBanner />
        <NoProjectErrorBanner />
        <TooManyProjectsErrorBanner />
        <TooManyConnectionsErrorBanner />
      </div>
    </Flex>
  )
}
